"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedFactorCrudAction = exports.MapOptimizerAction = void 0;
var MapOptimizerAction;
(function (MapOptimizerAction) {
    MapOptimizerAction["AddDirections"] = "add_directions";
    MapOptimizerAction["CalculateDistanceMatrix"] = "calculate_distance_matrix";
    MapOptimizerAction["CalculateDistanceMatrixWithMultipleTimeWindows"] = "calculate_distance_matrix_with_multiple_tw";
    MapOptimizerAction["CalculateRoutes"] = "calculate_routes";
    MapOptimizerAction["CalculateRoutesMatrix"] = "calculate_routes_matrix";
    MapOptimizerAction["CalculateIsochrone"] = "calculate_isochrone";
    MapOptimizerAction["ServiceAreaSpeedFactorsCRUD"] = "service_area_speed_factors_CRUD";
})(MapOptimizerAction || (exports.MapOptimizerAction = MapOptimizerAction = {}));
var SpeedFactorCrudAction;
(function (SpeedFactorCrudAction) {
    SpeedFactorCrudAction["Create"] = "create";
    SpeedFactorCrudAction["Read"] = "read";
    SpeedFactorCrudAction["Update"] = "update";
    SpeedFactorCrudAction["UpdateSeries"] = "update_series";
    SpeedFactorCrudAction["Delete"] = "delete";
    SpeedFactorCrudAction["DeleteSeries"] = "delete_series";
})(SpeedFactorCrudAction || (exports.SpeedFactorCrudAction = SpeedFactorCrudAction = {}));
//# sourceMappingURL=map_optimizer_types.js.map